module.exports = __webpack_public_path__ + "img/ico-search--black.d6fae0eb.svg";